import '../description-styles.scss';

const DescriptionItem = ({ product }) => {
  const { mainDescription, details } = product;

  const rows = [
    { label: 'Description', value: mainDescription },
    { label: 'Type de culture', value: details.cultureType },
    { label: 'Provenance', value: details.country },
    { label: 'Taux de CBD', value: details.rateCBD },
    { label: 'Taux de THC', value: details.rateTHC }
  ];

  return (
    <table className="product-details">
      <tbody>
        {rows.map(({ label, value }) => (
          <tr key={label}>
            <th scope="row">{label}</th>
            <td>{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DescriptionItem;
